import { render, staticRenderFns } from "./Authors.vue?vue&type=template&id=1b5cd876&scoped=true&"
import script from "./Authors.vue?vue&type=script&lang=ts&"
export * from "./Authors.vue?vue&type=script&lang=ts&"
import style0 from "./Authors.vue?vue&type=style&index=0&id=1b5cd876&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5cd876",
  null
  
)

export default component.exports